module.exports = __webpack_public_path__ + "static/media/hg2.18e43828.jpeg";